module.exports = "/assets/data/883e15969de1c27e184038060a19d7d1-SW6.data.json";